import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAsyncFn} from 'react-use';
import {
  getAllAppraisersUseCase,
  getAllSpeciesUseCase,
  opUploadForestMassUseCase,
  publishErrorUseCase,
} from '@/compositionRoot';
import type {UploadForestMass} from '@/domain/entities/Op';

export const useController = () => {
  const navigate = useNavigate();

  const [appraisers, fetchAppraisers] = useAsyncFn(() => getAllAppraisersUseCase.execute(), []);
  const [species, fetchSpecies] = useAsyncFn(() => getAllSpeciesUseCase.execute(), []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: Not necessary
  useEffect(() => {
    fetchAppraisers();
    fetchSpecies();
  }, []);

  const loading = appraisers.loading || species.loading;
  const error = appraisers.error || species.error;

  const handleUploadForestMass = async (entity: UploadForestMass, file: File) => {
    try {
      await opUploadForestMassUseCase.execute(entity, file);
      navigate('../');
    } catch (error) {
      publishErrorUseCase.execute(error as Error);
    }
  };

  const handleBack = () => navigate('../');

  return {
    appraisers: appraisers.value,
    species: species.value,
    loading,
    error,
    onUploadForestMass: handleUploadForestMass,
    onBack: handleBack,
  };
};
